import { FC, Fragment, useEffect, useState } from 'react';
import { getMe } from '../../store/idbHandler';
import { RunningDiagnosisStatusType, RunningDiagnosisStrip } from './RunningDiagnosisStrip';
import { checkTime } from './utils';

export const TimeCheck: FC<{
    onSuccess: (obj: { [k: string]: string }) => void;
    onFailure: (obj: { [k: string]: string }) => void;
}> = ({ children, onSuccess, onFailure }) => {
    const [status, setStatus] = useState<RunningDiagnosisStatusType>('running');

    const me = getMe();
    useEffect(() => {
        if (me) {
            checkTime()
                .then((res) => {
                    onSuccess(res);
                    setStatus('success');
                })
                .catch((err) => {
                    onFailure(err);
                    setStatus('failed');
                });
        }
    }, []);

    return (
        <Fragment>
            <RunningDiagnosisStrip name="Checking system time & timezone" status={status} />
            {children}
        </Fragment>
    );
};
